<div class="container">
  <h1 class="title">Business Account:</h1>
  <div class="select">
    <!-- <select [(ngModel)]="baidSelection"> -->
    <select (change)="baidSelect()" [(ngModel)]="selectedBaid">
      <option
        *ngFor="let opt of (baidOptions$ | async)"
        [value]="opt.businessAcctObj.businessAccountId"
      >
        NAME: {{ opt.businessAcctObj.accountName }}, ID:
        {{ opt.businessAcctObj.businessAccountId }}, PROV. MODE:
        {{ opt.businessAcctObj.provMode }}, PROV. TYPE:
        {{ opt.businessAcctObj.provType }}</option
      >
    </select>
  </div>
</div>
